import { Injectable } from '@angular/core';
import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { checklistDatesFromApi, checklistDatesToApi } from '../utils/calendar-day.util';

/**
 * Checklist row dates are calendar days, stored by the Inspection API as the day's UTC
 * midnight. This converts them to the browser's local midnight on the way in and back on
 * the way out, so a row shows and saves as the same day in every time zone (see
 * calendar-day.util.ts). Only Inspection API calls, and only checklist rows: other dates
 * keep their current handling.
 */
@Injectable()
export class ChecklistDatesInterceptor implements HttpInterceptor {
  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    if (!req.url.startsWith(environment.API_INSPEC)) {
      return next.handle(req);
    }

    const outgoing = isJsonBody(req.body) ? req.clone({ body: checklistDatesToApi(req.body) }) : req;
    return next.handle(outgoing).pipe(
      map(event => event instanceof HttpResponse && isJsonBody(event.body)
        ? event.clone({ body: checklistDatesFromApi(event.body) })
        : event)
    );
  }
}

function isJsonBody(body: unknown): boolean {
  return typeof body === 'object'
    && body !== null
    && !(body instanceof FormData)
    && !(body instanceof Blob)
    && !(body instanceof ArrayBuffer)
    && !(body instanceof URLSearchParams);
}
